module.exports = __webpack_public_path__ + "dc03940d.svg";